import { api, request } from './client.js';

const root = '/me';

/**
 * Customer portal API (Phase 4). Self-scoped: every call resolves to the
 * authenticated owner's own customer through the server-side userId link.
 */
export const portalApi = {
  getCustomer: () => api.get(`${root}/customer`),
  getPets: () => api.get(`${root}/pets`),
  getTimeline: (petId) => api.get(`${root}/pets/${petId}/timeline`),
  getWellness: (petId) => api.get(`${root}/pets/${petId}/wellness`),
  getNutrition: (petId) => api.get(`${root}/pets/${petId}/nutrition`),
  uploadPhoto: (petId, formData) => api.post(`${root}/pets/${petId}/photos`, formData),
  claim: (token) => api.post(`${root}/claim`, { token }),
  requestDataExport: () => api.post(`${root}/data-export`, {}),
  erase: (body) => api.post(`${root}/portal/erasure`, body),

  // ---- Assistant ----------------------------------------------------------
  // The assistant is strictly scoped to the owner's own data server-side; the
  // client never sends a customer identifier.
  assistantConfig: () => api.get(`${root}/assistant/config`),
  assistantChat: (body) => api.post(`${root}/assistant/chat`, body),
  assistantConversations: () => api.get(`${root}/assistant/conversations`),
  assistantConversation: (id) => api.get(`${root}/assistant/conversations/${id}`),
  assistantDeleteConversation: (id) => api.delete(`${root}/assistant/conversations/${id}`),

  /**
   * Streaming assistant turn over Server Sent Events. Calls onEvent(evt) for
   * each frame (agent / delta) and resolves with the final `done` frame.
   */
  async assistantChatStream(body, { onEvent, signal } = {}) {
    const res = await request(`${root}/assistant/chat/stream`, {
      method: 'POST',
      body,
      raw: true,
      signal
    });
    if (!res.ok || !res.body) {
      const err = new Error('Stream request failed');
      err.statusCode = res.status;
      throw err;
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let final = null;

    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf('\n')) >= 0) {
        const line = buffer.slice(0, idx).trim();
        buffer = buffer.slice(idx + 1);
        if (!line.startsWith('data:')) continue;
        const payload = line.slice(5).trim();
        if (payload === '[DONE]') return final;
        let evt;
        try { evt = JSON.parse(payload); } catch { continue; }
        if (evt.type === 'done') {
          final = evt;
        } else if (evt.type === 'error') {
          const err = new Error(evt.message || 'Stream error');
          err.code = 'STREAM_ERROR';
          throw err;
        } else if (typeof onEvent === 'function') {
          onEvent(evt);
        }
      }
    }
    return final;
  }
};
